import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client/react';
import first from 'lodash/first';
import RefreshTokenService from 'services/RefreshTokenService';
import {
  QuickCalculatorDocument,
  type QuickCalculatorMutation,
  type QuickCalculatorMutationVariables,
  ProjectsDocument,
  MeDocument,
  type MeQuery,
  type QuickCalculatorInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';
import useUser from './user/useUser';

const useQuickCalculatorMutation = () => {
  const client = useApolloClient();
  const [me] = useUser();

  const quickCalculator = useCallback(
    async (variables: QuickCalculatorInput) => {
      try {
        const res = await client.mutate<QuickCalculatorMutation, QuickCalculatorMutationVariables>({
          mutation: QuickCalculatorDocument,
          variables: { formData: { ...variables } },
          refetchQueries: me ? [{ query: ProjectsDocument }] : [],
        });

        const result = requireValue(
          first(Object.values(requireValue(res.data, 'data'))),
          'refreshToken',
        );
        if (result.refreshToken) {
          RefreshTokenService.setRefreshToken(result.refreshToken);
        }
        if (!me) client.writeQuery<MeQuery>({ query: MeDocument, data: { me: result.user } });

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [client, me],
  );
  return quickCalculator;
};

export default useQuickCalculatorMutation;
